import '@/app/app.css';
import './library.css';

import { SubscribeForm } from '@/features/subscribe/subscribe';
import { LibrarySearch } from '@/features/library/library-search/library-search';
import { LibrarySearchSelect } from '@/features/library/library-search-select/library-search-select.js';
import { LibrarySearchSecondary } from '@/features/library/library-search-secondary/library-search-secondary.js';

import '@/app/app';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-subscribe-form').forEach((element) => new SubscribeForm(element));
	document.querySelectorAll('.js-library-search').forEach((element) => new LibrarySearch(element));
	document.querySelectorAll('.library-search-select').forEach((element) => new LibrarySearchSelect(element));
	document.querySelectorAll('.library-search-secondary').forEach((element) => new LibrarySearchSecondary(element));
});
